<form [formGroup]="editFieldInputForm" style="margin-top: 20px">
  <div class="choices">
    <mat-label class="title">Liste des choix :</mat-label>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Saisie assistée">
        <ul formArrayName="choices">
          <li [formGroupName]="i"
              *ngFor="let option of editFieldInputForm.controls?.choices['controls']; let i = index">
            <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
              <mat-label>choix {{i + 1}}</mat-label>
              <input formControlName="key" matInput
                     matTooltip="Saisir ici le libellé du choix"
                     name="choice"
                     placeholder="Libellé du choix"
                     (focusout)="sendChoices()"
                     type="text">
            </mat-form-field>
            <button (click)="removeField(i)"
                    mat-raised-button
                    color="primary"
                    type="button"
                    [disabled]="editFieldInputForm.controls?.choices['controls'].length <= fieldsLimit">
              <mat-icon aria-hidden="false" aria-label="Ajout" data-cy="icon-choice-list-remove">remove</mat-icon>
            </button>
          </li>
        </ul>
        <ul>
          <li>
            <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
              <mat-label>choix supplémentaire</mat-label>
              <input #suppField
                     matInput
                     formControlName="suppField"
                     matTooltip="Saisir un choix supplémentaire"
                     name="choice"
                     placeholder="Libellé du choix supplémentaire"
                     type="text">
            </mat-form-field>
            <button (click)="addField()"
                    mat-raised-button
                    color="green"
                    type="button"
                    [disabled]="!editFieldInputForm.get('suppField').value">
              <mat-icon aria-hidden="false" aria-label="Ajout">add</mat-icon>
            </button>
          </li>
        </ul>
      </mat-tab>

      <mat-tab label="Saisie libre" matTooltip="">
        <mat-form-field appearance="outline" fxFlex="calc(100%)">
          <mat-label>Saisir ici les libellés des choix, un par ligne</mat-label>
          <textarea formControlName="choices_text" matInput
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="4"
                    cdkAutosizeMaxRows="10"
                    matTooltip="Saisir ici les libellés des choix, un par ligne"
                    placeholder="Libellé du choix"
                    (input)="updateChoicesFromList()"
                    (focusout)="sendChoices()" data-cy="txtarea-choice-list-libelle">
          </textarea>
        </mat-form-field>
      </mat-tab>
    </mat-tab-group>
  </div>
</form>
